import { render, staticRenderFns } from "./PaymentPendingBanner.vue?vue&type=template&id=671a0083&"
import script from "./PaymentPendingBanner.vue?vue&type=script&lang=js&"
export * from "./PaymentPendingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671a0083')) {
      api.createRecord('671a0083', component.options)
    } else {
      api.reload('671a0083', component.options)
    }
    module.hot.accept("./PaymentPendingBanner.vue?vue&type=template&id=671a0083&", function () {
      api.rerender('671a0083', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/app/PaymentPendingBanner.vue"
export default component.exports